import classNames from "classnames";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const RenderMarkdown = ({
  children,
  usePreWrapper = true,
  className = "",
}: {
  children?: string;
  usePreWrapper?: boolean;
  className?: string;
}) => {
  return usePreWrapper ? (
    <>
      <pre className={classNames("whitespace-pre-wrap font-fustat", className)}>
        {children}
      </pre>
    </>
  ) : (
    <div className={classNames("markdown font-fustat", className)}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {children ?? ""}
      </ReactMarkdown>
    </div>
  );
};
